import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import Input from 'component/utils/Input'
import InputFile from 'component/utils/InputFile'
import ProgressBar from 'component/utils/ProgressBar'
import InputHour from 'component/form/InputHour'
import Editor from 'component/HtmlEditor'
import Glyph from 'component/utils/Glyph'
import HelpSelect from 'component/helpConfiguration/select/HelpSelect'
import TagSelect from 'component/helpConfiguration/select/TagSelectMultiple'
import firebase from 'utils/Firebase'
import iconAdd from 'images/add.svg'

class HelpConfigModalEdit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      uploading: false,
      progress: false,
      dsFileName: '',
      index: [],
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (!state.index.length) {
      if (props.initialValues.listHelpConfigIndexPresenter) {
        return {
          index: props.initialValues.listHelpConfigIndexPresenter,
        }
      }
    }
    return null
  }

  handleSubmit = (e) => {
    e.preventDefault()

    const { values, onSubmit, initialValues } = this.props

    if (values.typeConfig === '0') {
      const data = {
        idHelpConfig: initialValues.idHelpConfig,
        typeConfig: values.typeConfig,
        cdMenu: values.cdMenu,
        dsTitle: values.dsTitle,
        listHelpTagParam: values.listIdHelpTag.map((e) => ({
          idHelpTag: e.value !== e.label ? e.value : null,
          dsHelpTag: e.label,
        })),
        dsHelp: values.dsHelp,
      }
      onSubmit(data)
    } else {
      const { index } = this.state
      const data = {
        idHelpConfig: initialValues.idHelpConfig,
        typeConfig: values.typeConfig,
        cdMenu: values.cdMenu,
        dsHelp: values.dsHelp,
        listHelpConfigIndexParam: index.filter((e) => e.nuTime),
      }
      onSubmit(data)
    }
  }

  handleMenuChange = (value) => {
    const { setValueToField } = this.props
    setValueToField('cdMenu', value)
  }

  handleMenuTag = (value) => {
    const { setValueToField } = this.props
    setValueToField('listIdHelpTag', value)
  }

  handleFilesChange = async (event) => {
    const inputFiles = event.target.files

    /* istanbul ignore else */
    if (inputFiles && inputFiles[0]) {
      this.uploadToFirebase(inputFiles[0])
    }
  }

  uploadToFirebase = (file) => {
    this.setState({
      dsFileName: file.name,
      progress: 0,
      uploading: true,
    })

    // Creates a root reference
    const storageRef = firebase.storage().ref()

    const fileName = new Date().valueOf() + file.name

    // Uploads file
    const uploadTask = storageRef.child('help-config').child(fileName).put(file)

    // Listens for state changes, errors, and completion of the upload
    uploadTask.on(
      firebase.storage.TaskEvent.STATE_CHANGED,
      this.firebaseUpdateProgress,
      this.firebaseUploadError,
      () => {
        // Upload completed successfully, now we can get the download URL
        uploadTask.snapshot.ref.getDownloadURL().then(this.updateFileUrl)
      }
    )
  }

  firebaseUpdateProgress = (snapshot) => {
    // Gets task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
    this.setState({ progress })
  }

  firebaseUploadError = (error) => {
    this.setState({ uploading: false, progress: 0 })
    console.error(error)
  }

  updateFileUrl = (downloadURL) => {
    const { setValueToField } = this.props
    setValueToField('dsHelp', downloadURL)

    this.setState({ uploading: false, progress: 0 })
  }

  renderText = () => {
    const { translate, fields, values, user, setValueToField, disabled } =
      this.props

    return (
      <>
        <Row className='padding-top padding-bottom'>
          <Col className='strong' xs={12} md={12}>
            <span>{translate('label.help.config.dsFunc')}</span>
          </Col>
          <Col xs={12} md={12}>
            <Field {...fields.cdMenu}>
              <HelpSelect
                {...fields.cdMenu.input}
                user={user}
                onChange={this.handleMenuChange}
                value={fields.cdMenu.input.value}
                translate={translate}
                disabled
                placeholder={translate('hint.help.config.dsFunc')}
              />
            </Field>
          </Col>
        </Row>

        <Row className='padding-top padding-bottom'>
          <Col className='strong' xs={12} md={12}>
            <span>{translate('label.help.config.dsTitle')}</span>
          </Col>
          <Col xs={12} md={12}>
            <Field {...fields.dsTitle} error={translate(fields.dsTitle.error)}>
              <Input
                id='dsTitle'
                {...fields.dsTitle.input}
                disabled={disabled}
                placeholder={translate('hint.help.config.dsTitle')}
              />
            </Field>
          </Col>
        </Row>

        <Row className='padding-top padding-bottom'>
          <Col className='strong' xs={12} md={12}>
            <span>{translate('label.help.config.tags')}</span>
          </Col>
          <Col xs={12} md={12}>
            <Field {...fields.listIdHelpTag}>
              <TagSelect
                {...fields.listIdHelpTag.input}
                values={fields.listIdHelpTag.input.value}
                placeholder={translate('hint.help.config.tags')}
                onChange={this.handleMenuTag}
                user={user}
                translate={translate}
                disabled={disabled}
              />
            </Field>
          </Col>
        </Row>

        <Row className='padding-top padding-bottom'>
          <Col xs={12} md={12} className='padding-bottom strong'>
            <span>{translate('label.help.config.instructions')}</span>
          </Col>

          <Col xs={12} md={12}>
            <Editor
              value={values.dsHelp}
              onTextChange={(e) => setValueToField('dsHelp', e.htmlValue)}
              disabled={disabled}
              completeHeader
            />
          </Col>
          <Col xs={12} md={12} className='padding-bottom color-default-dark'>
            <span>{translate('hint.help.config.min')}</span>
          </Col>
        </Row>
      </>
    )
  }

  renderVideo = () => {
    const { translate, fields, values, user, disabled } = this.props
    const { index, uploading, progress } = this.state

    const inputFileDisabled = values.dsHelp || uploading || disabled

    return (
      <>
        <Row className='padding-top padding-bottom'>
          <Col className='strong' xs={12} md={12}>
            <span>{translate('label.help.config.dsFunc')}</span>
          </Col>
          <Col xs={12} md={12}>
            <Field {...fields.cdMenu}>
              <HelpSelect
                {...fields.cdMenu.input}
                user={user}
                onChange={this.handleMenuChange}
                value={fields.cdMenu.input.value}
                translate={translate}
                disabled
                video
                placeholder={translate('hint.help.config.dsFunc')}
              />
            </Field>
          </Col>
        </Row>

        <Row className='padding-top padding-bottom'>
          <Col className='strong' xs={12} md={12}>
            <span>{translate('label.help.config.attach.video')}</span>
          </Col>
          <Col xs={12} md={12}>
            <Field {...fields.dsHelp} error={translate(fields.dsHelp.error)}>
              {!inputFileDisabled && (
                <InputFile
                  id='dsHelp'
                  disabled={inputFileDisabled}
                  className='margin-vertical-small'
                  translate={translate}
                  setInputRef={this.setInputRef}
                  sideText={translate('videos.dsHelp')}
                  {...fields.dsHelp.input}
                  onChange={this.handleFilesChange}
                  accept={['video/mp4']}
                  maxSize={15000000}
                  bottomLabel={translate('label.help.config.valid.file')}
                />
              )}

              {uploading && <ProgressBar percent={progress} />}

              {values.dsHelp && (
                <Input
                  id='dsHelp'
                  disabled
                  className='margin-vertical-small'
                  translate={translate}
                  {...fields.dsHelp.input}
                  value={values.dsHelp}
                />
              )}
            </Field>
          </Col>
        </Row>

        <Row className='padding-top padding-bottom'>
          <Col className='strong' xs={12} md={12}>
            <span>{translate('label.help.config.index')}</span>
          </Col>
        </Row>

        {index && index.map(this.renderIndex)}

        {!disabled && (
          <Row className='padding-top padding-bottom'>
            <Col xs={12} md={12}>
              <div className='flex index-add'>
                <img src={iconAdd} onClick={this.addIndex} />
                <legend>{translate('label.help.config.add.index')}</legend>
              </div>
            </Col>
          </Row>
        )}
      </>
    )
  }

  renderIndex = (e, i) => {
    const { disabled, translate } = this.props
    return (
      <Row className={'padding-top padding-bottom'}>
        <Col xs={2} md={2}>
          <div>
            <div className='strong'>
              <span>{translate('option.time')}</span>
            </div>
            <InputHour
              id={`nutime-${i}`}
              value={e.nuTime}
              name={'nuTime'}
              onChange={(event) => this.changeIndex(event, i)}
              disabled={disabled}
              maxLength={8}
            />
          </div>
        </Col>

        <Col xs={9} md={9}>
          <div>
            <div className='strong'>
              <span>{translate('option.description')}</span>
            </div>
            <Input
              id={`dsIndex-${i}`}
              name={'dsIndex'}
              value={e.dsIndex}
              onChange={(event) => this.changeIndex(event, i)}
              disabled={disabled}
            />
          </div>
        </Col>

        <Col>
          <div>
            <span
              className={'index-remove'}
              disabled={disabled}
              onClick={() => this.removeIndex(i)}
            >
              <Glyph type='x' color='text' />
            </span>
          </div>
        </Col>
      </Row>
    )
  }

  changeIndex = (event, i) => {
    const { name, value } = event.target
    const { index } = this.state
    index[i][name] = value
    this.setState({ index })
  }

  removeIndex = (data) => {
    const { index } = this.state
    this.setState({
      index: index.filter((e, i) => i !== data),
    })
  }

  addIndex = () => {
    const { index } = this.state
    index.push({ nuTime: null, dsIndex: null })
    this.setState({
      index,
    })
  }

  checkDisabled = () => {
    const { values } = this.props
    if (values.cdMenu) {
      if (
        values.typeConfig === '0' &&
        values.dsHelp &&
        values.dsTitle &&
        values.listIdHelpTag &&
        values.listIdHelpTag.length > 0 &&
        values.dsHelp.length > 300
      ) {
        return
      }
      if (values.typeConfig === '1' && values.dsHelp) {
        return
      }
    }

    return 'disabled'
  }

  render() {
    const { translate, values, disabled, closeModal } = this.props

    return (
      <section>
        <form className='help-config-form'>
          <Row>
            <Col xs={12} className={'justify-content-center strong'}>
              <legend className='margin-top margin-bottom'>
                {translate(
                  `label.help.config.help.${disabled ? 'view' : 'edit'}`
                )}
              </legend>
            </Col>
          </Row>

          {values.typeConfig === '0' && this.renderText()}
          {values.typeConfig === '1' && this.renderVideo()}

          <Row className='padding'>
            <Col xsOffset={4} xs={4} mdOffset={4} md={4}>
              <button
                role='button'
                onClick={disabled ? closeModal : this.handleSubmit}
                className={`button button-primary button-full align-center ${this.checkDisabled()}`}
              >
                {translate(`buttom.help.config.${disabled ? 'view' : 'edit'}`)}
              </button>
            </Col>
          </Row>
        </form>
      </section>
    )
  }
}

HelpConfigModalEdit.propTypes = {
  translate: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  setValueToField: PropTypes.func.isRequired,
  user: PropTypes.object,
  disabled: PropTypes.bool,
}

const fields = ['typeConfig', 'cdMenu', 'listIdHelpTag', 'dsTitle', 'dsHelp']

export default Form({ fields })(HelpConfigModalEdit)

export { HelpConfigModalEdit }
